import { Outlet } from "react-router-dom";

import { CityChooserDialog } from "@/components/CityChooserDialog";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";

/**
 * Layout wrapper for public-facing pages (Landing, Cinemas, Movies,
 * Movie detail). The header is transparent by default — the Landing
 * page's hero sits directly under it; interior pages can pass
 * `transparent={false}` by wrapping differently if needed.
 */
export function PublicLayout({
  headerTransparent = true,
}: {
  headerTransparent?: boolean;
}) {
  return (
    <>
      <Header transparent={headerTransparent} />
      <main className="min-h-screen bg-white text-rc-black">
        <Outlet />
      </main>
      <Footer />
      {/* Primera visita: elegir ciudad (solo páginas públicas; login/auth quedan fuera). */}
      <CityChooserDialog />
    </>
  );
}
